import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ChatroomProvider } from './contexts/ChatroomContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { ChatPage } from './pages/ChatPage';
import './App.css';

function ProtectedChatPage() {
  return (
    <ProtectedRoute>
      <ChatroomProvider>
        <ChatPage />
      </ChatroomProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter basename="/chatrooms">
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedChatPage />} />
          <Route path="/:spaceSlug/:channelSlug" element={<ProtectedChatPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
